import {combineReducers} from "redux";

import login, {LoginState} from "./login/reducer";
import projects, {ProjectsState} from "./projects/reducer";
import project, {ProjectState} from "./projects/project/reducer";
import users, {UsersState} from "./users/reducer";


export interface RoutesState {
  login: LoginState;

  projects: ProjectsState;
  project: ProjectState;
  users: UsersState;
}

export default combineReducers<RoutesState>({
  login,
  projects,
  project,
  users,
});




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/reducer.ts